module.exports = __webpack_public_path__ + "static/media/CUSTOMERSERVICE.163230c5.jpg";